// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__fqeBN","error":"Form_error__8gzF4"};